export default {
    gurusData: [],
    gurusPersekolahData: [],
    errors: [],
    gurusQueuePersekolahData: [],
    gunduksPersekolahData: [],
    gunduksPersekolahDataAktif: [],
    gukelsPersekolahData: [],
    semuaGukels: [],
    mugusPersekolahData: [],
    semuaMugus: [],
}